/**
 * Site Settings V2 — "General" section: site name, description, and
 * the on-site location-notes free-text field.
 *
 * Contains:
 * - GeneralSection (default export)
 */

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  SettingsFieldRow,
  SettingsSection,
  SettingsSubsection,
  SettingsTextField,
} from '@sophocles/views/settings/components';

export default function GeneralSection() {
  const { t } = useTranslation();
  return (
    <SettingsSection
      id="settings-general"
      icon={<InfoOutlinedIcon />}
      title={t('siteSettings.v2.general', 'General')}
      description={t('siteSettings.v2.generalDescription', 'Site name, description, and on-site location notes.')}
    >
      <SettingsSubsection title={t('siteSettings.v2.identity', 'Identity')} bordered>
        <SettingsFieldRow
          label={t('general.name', 'Name')}
          description={t('siteSettings.v2.nameDescription', "The site's display name.")}
          controlWidth={320}
          required
        >
          <SettingsTextField name="general.name" hiddenLabel fullWidth />
        </SettingsFieldRow>
        <SettingsFieldRow
          label={t('general.description', 'Description')}
          description={t('siteSettings.v2.descriptionDescription', 'Optional summary about this site.')}
          controlWidth={400}
        >
          <SettingsTextField name="general.description" hiddenLabel fullWidth multiline minRows={2} />
        </SettingsFieldRow>
        <SettingsFieldRow
          label={t('siteSettings.locationDescription', 'Location Description')}
          description={t(
            'siteSettings.v2.locationDescriptionHelp',
            'On-site landmarks or access notes for technicians.',
          )}
          controlWidth={400}
        >
          <SettingsTextField name="general.location_description" hiddenLabel fullWidth multiline minRows={2} />
        </SettingsFieldRow>
      </SettingsSubsection>
    </SettingsSection>
  );
}
